import 'zone.js/plugins/zone-error';
const baseUrl = 'staging-01.pia.publicare-gmbh.de';
export const environment = {
  production: true,
  disableDeploy: false,
  baseUrl,
  branch: 'staging',
  stage: 'staging-01',
  o365Scopes: ['user.read'],
  firebase: {
    apiKey: 'AIzaSyAD6FKSPI29FC8QYsJuqq9qWKsFwlIYy9o',
    authDomain: 'pia-dev-cf02a.firebaseapp.com',
    projectId: 'pia-dev-cf02a',
    storageBucket: 'pia-dev-cf02a.appspot.com',
    messagingSenderId: '684228989784',
    appId: '1:684228989784:web:145910b21c13dddc3b0b2d',
  },
  authCodeFlowConfigWeb: {
    issuer: `https://auth.${baseUrl}`,
    redirectUri: window.location.origin,
    clientId: '41dee0a7-87e9-4959-b38a-baaec4473177',
    responseType: 'code',
    scope: 'openid offline_access',
    clearHashAfterLogin: true,
    showDebugInformation: true,
    skipIssuerCheck: true,
  },
  authCodeFlowConfigApp: {
    client_id: '41dee0a7-87e9-4959-b38a-baaec4473177',
    server_host: `https://auth.${baseUrl}`,
    redirect_url: 'appauth://callback',
    end_session_redirect_url: 'appauth://endsession',
    scopes: 'openid offline_access',
    pkce: true,
  },
  codePushDeploymentKeys: [
    { deploymentKey: '', platform: 'android', deployment: 'dev' },
    { deploymentKey: '', platform: 'android', deployment: 'staging' },
    { deploymentKey: '', platform: 'android', deployment: 'production' },
    { deploymentKey: '', platform: 'ios', deployment: 'dev' },
    { deploymentKey: 'ZirPx4JDAfTQgV3_v2oAauLflROMD8b-rNAS6', platform: 'ios', deployment: 'staging' },
    { deploymentKey: '5y8KUy5KEnGWOCJxfcw264a63c2dIF8JbbalM', platform: 'ios', deployment: 'production' },
  ],
  stimulsoftLicense:
    '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkyf6GCtMIvMrFSuO65hDII/QxiVSjc6dLKFeN+mcA+0g9Y8N' +
    'YAkJWK1pE0VMMEuPCcbPX4qqV/OscTTDZ9nZkNY1ZsJ+IXvS1tjgciZIPEhZuTKiWUkl9emnEch7g/tOA/M0Lrrzh5' +
    'uAeiRBh1C6PaZMi9GlwqZXPZS8TWURbZm1CKvuRC49Lk8b6U663R/LgjzaH0dzOGZOndv0NcDFSgy7IHLPuJMTgIGJ' +
    'd7Hoqsh1nHsZ6bJiS108btCoAxsi/7M2foOje3BiJj3I5Q+Dj+/L2eeczjrKE92CUxAlPBqMnXha3/MLylWJF1lchE' +
    'DTclhy+03+blMfwCp+1Liy2VwZAx1g1pliwaO1zkJtVCK0Zx200kEGqlD4w4+EMPHVmAaDZmpx/mOGBV+LzpL5NxLz' +
    'V/hbRgbSWdiB0eC6mRGpMmhPAfkZYw/lG22gW5MpcYey4nlpGn4Cnk4GXvzwoLzWkEaLCXx2xKTOZOP2tBvAU4nkcx' +
    'aCqQo9h9BE5D+tyGy1bQE6oTkEnjPDIvhb6K',
  calendar: {
    settingsPath: `${baseUrl}/setting/calendar`,
    apiPath: `api.${baseUrl}/calendar`,
    helpLink: {
      url: `https://puma.publicare-gmbh.de/display/HILFEPIA/HILFE.PIA`,
      label: `hilfe.pia`,
    },
    appLinkLabel: `${baseUrl}`,
    clientId: '38a0778d-b245-489a-9ccd-46185f7e6ef5',
    redirectUri: `https://${baseUrl}`,
  },
  encryption: {
    regex: null,
    settings: [],
  },
  sendAllCommandsToEmail: `FullStack@publicare-gmbh.de`,
  environmentSettings: {
    apiUrl: `https://api.${baseUrl}`,
    swodocUrl: `https://formulare.${baseUrl}`,
  },
  createTenant: {
    defaultUserSuffix: `${baseUrl}`,
  },
  validITLabsUser: ['Nico.Nussbaum@publicare-gmbh.de', 'Victor.Wiesenmueller@publicare-gmbh.de'],
  markerjs2Key: 'MJS2-P947-M765-5857',
  sentry: {
    dsn: 'https://6a911805e47c1454fabcd1cdd9ed0edc@o493535.ingest.us.sentry.io/4511580466642944',
  },
};
